// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Hbpu","content":"RecentSearches_content__2pY16"};